import { LandingPage as LandingPageForm } from '@bgea-js/form-templates';
import decisionMagazineHardCopy from "../../../../src/content/pray-for-president/customConfirmationHardcopy";
import "../../../../src/content/pray-for-president/pray-president.scss";
import * as React from 'react';
export default {
  LandingPageForm,
  decisionMagazineHardCopy,
  React
};